import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const TOKEN_KEY = 'nymo_auth_token'

const WARDEN_BASE = import.meta.env.VITE_WARDEN_URL || 'https://warden.kcolb.com'
const WARDEN_CLIENT_ID = import.meta.env.VITE_WARDEN_CLIENT_ID || 'nymo'
const WARDEN_REDIRECT_URI = import.meta.env.VITE_WARDEN_REDIRECT_URI || undefined

function generateState(): string {
  const arr = new Uint8Array(32)
  crypto.getRandomValues(arr)
  return Array.from(arr, (b) => b.toString(16).padStart(2, '0')).join('')
}

export default function Login() {
  const { isAuthenticated, isLoading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading) return // Wait for auth state to initialize

    if (isAuthenticated || localStorage.getItem(TOKEN_KEY)) {
      navigate('/', { replace: true })
      return
    }

    // Redirect to Warden login with the authorize flow baked in
    const state = generateState()
    sessionStorage.setItem('warden_auth_state', state)

    const authorizeParams = new URLSearchParams({
      client_id: WARDEN_CLIENT_ID,
      state,
    })
    if (WARDEN_REDIRECT_URI) authorizeParams.set('redirect_uri', WARDEN_REDIRECT_URI)

    const wardenLoginUrl = `${WARDEN_BASE}/login?redirect=${encodeURIComponent(`/authorize?${authorizeParams.toString()}`)}`
    window.location.href = wardenLoginUrl
  }, [isLoading, isAuthenticated, navigate])

  return (
    <main className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="text-center">
        <div className="w-5 h-5 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-text-muted">Redirecting to sign in...</p>
      </div>
    </main>
  )
}
